import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSetAtom } from 'jotai';
import useSWR from 'swr';

import { authService } from 'v2/api/authService';
import { userAtom } from 'v2/atoms/userAtom';
import { AppRoute } from 'v2/routes';

export function useCheckAuth(): boolean {
  const navigate = useNavigate();

  const setUser = useSetAtom(userAtom);

  const [isAuthChecking, setAuthChecking] = useState(true);

  useSWR('checkAuth', authService.checkAuth, {
    onSuccess: (data) => {
      setUser(data);
      setAuthChecking(false);
    },
    onError: () => {
      navigate(AppRoute.LOGIN_PAGE);
      setAuthChecking(false);
    },
  });

  return isAuthChecking;
}
